import { create } from 'zustand';

export const useWebhookSubscriptionStore = create((set) => ({
    items: [],
    deliveries: [],
    selectedSubscription: null,
    testResult: null,
    loading: false,
    deliveriesLoading: false,
    error: null,
    deliveriesPagination: { page: 1, pageSize: 20, total: 0, totalPages: 1 },
    isFormDialogOpen: false,
    isDetailOpen: false,
    isTestResultOpen: false,
    setItems: (items) => set({ items }),
    setDeliveries: (deliveries) => set({ deliveries }),
    setSelectedSubscription: (selectedSubscription) => set({ selectedSubscription }),
    setTestResult: (testResult) => set({ testResult }),
    setLoading: (loading) => set({ loading }),
    setDeliveriesLoading: (deliveriesLoading) => set({ deliveriesLoading }),
    setError: (error) => set({ error }),
    setDeliveriesPagination: (deliveriesPagination) => set({ deliveriesPagination }),
    setIsFormDialogOpen: (isFormDialogOpen) => set({ isFormDialogOpen }),
    setIsDetailOpen: (isDetailOpen) => set({ isDetailOpen }),
    setIsTestResultOpen: (isTestResultOpen) => set({ isTestResultOpen }),
}));

export default useWebhookSubscriptionStore;
